function PhoneEmpty({ style }) {
  const { fill = '#63637B', width = 32, height = 32 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        stroke={fill}
        strokeLinecap="square"
        strokeWidth="2"
        d="m9.186 6 3.978 3.978L11.34 11.8c-.264.264 1.671 3.33 3.813 5.47 2.14 2.142 4.78 3.651 5.044 3.387l1.823-1.823L26 22.814l-2.081 2.082c-1.197 1.197-3.054 1.459-4.516.603-1.993-1.166-2.923-1.597-6.9-5.575-3.978-3.978-4.834-5.332-6-7.326-.855-1.46-.594-3.319.602-4.515L9.186 6Z"
      />
    </svg>
  );
}

export default PhoneEmpty;
